import React from "react";
import { Box, Typography, useTheme, alpha, useMediaQuery } from "@mui/material";

const PageHeader = ({
  title,
  subtitle,
  icon: Icon,
  primaryAction,
  secondaryActions,
  backgroundColor,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        mb: 3,
        p: { xs: 1.5, sm: 2 },
        backgroundColor: backgroundColor || theme.palette.background.paper,
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
        }}
      >
        {/* Left Side */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          {Icon && (
            <Box
              sx={{
                width: { xs: 34, sm: 38 }, // was 40/50
                height: { xs: 34, sm: 38 },
                borderRadius: "10px", // slightly softer than borderRadius:2
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                color: theme.palette.primary.main,
              }}
            >
              <Icon sx={{ fontSize: { xs: 18, sm: 20 } }} /> {/* was 24/28 */}
            </Box>
          )}

          <Box>
            <Typography
              sx={{
                fontWeight: 700,
                color: theme.palette.text.primary,
                fontSize: { xs: "0.9rem", sm: "0.975rem" }, // was 1.25/1.5rem
                lineHeight: 1.3,
                letterSpacing: "-0.01em",
                mb: subtitle ? 0.3 : 0,
              }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography
                sx={{
                  color: theme.palette.text.secondary,
                  fontSize: { xs: "0.72rem", sm: "0.775rem" }, // was 0.813/0.875rem
                  lineHeight: 1.4,
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>

        {/* Right Side */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            width: { xs: "100%", sm: "auto" },
          }}
        >
          {secondaryActions}
          {primaryAction}
        </Box>
      </Box>
    </Box>
  );
};

export default PageHeader;
